import { render } from "./EmojiPickerComponent.vue?vue&type=template&id=4436b726&scoped=true"
import script from "./EmojiPickerComponent.vue?vue&type=script&lang=js"
export * from "./EmojiPickerComponent.vue?vue&type=script&lang=js"

import "./EmojiPickerComponent.vue?vue&type=style&index=0&id=4436b726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4436b726"]])

export default __exports__